import { css } from '@emotion/core';
import { findLastIndex, unset } from 'lodash';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../utils/constants';

export const containerSizesTop = {
  '.bannerbg': {
    background: 'linear-gradient(90deg,rgba(0,0,0,.8),transparent)',
  },
  [MediaQueries.sm]: {
    paddingBottom: '0px',
    paddingTop: '0px',
  },

  img: {
    width: '100%',
    position: 'absolute',
    height: '773px',
    objectFit: 'cover',
    zIndex: -1,
  },

  '.contentsec ': {
    marginLeft: '8.333333333333332%',
    color: '#fff',
    [MediaQueries.sm]: {
      marginLeft: '0',
    },

    '.texttop': {
      paddingTop: '150px',
      paddingBottom: '224px',
      [MediaQueries.sm]: {
        paddingTop: '50px',
        paddingBottom: '50px',
      },
      [MediaQueries.md]: {
        paddingTop: '50px',
        paddingBottom: '50px',
      },

      '.img_icon': {
        marginBottom: '24px',
        display: 'block',

        img: {
          width: 'auto',
          height: 'auto',
          position: 'relative',
          zIndex: 'unset',
        },
      },

      '.ptext': {
        marginTop: '32px',
        color: '#fff',
      },
    },

    h2: {
      fontSize: '58px',
      fontWeight: '500',
      lineHeight: '56px',
      letterSpacing: '-1px',
      maxWidth: '620px',
      marginBottom: '24px',

      [MediaQueries.sm]: {
        fontSize: '40px',
        fontWeight: '500',
        lineHeight: '48px',
        letterSpacing: '-0.3px',
        marginBottom: '24px',
      },
    },

    p: {
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '32px',
      letterSpacing: '0px',
    },
  },
  '.callsectionbg': {
    paddingBottom: '32px',
    '.callsec': {
      minHeight: '120px',
      justifyContent: 'space-between',
      background: 'rgba(255, 255, 255)',
      backdropFilter: 'blur(24px)',
      borderRadius: '8px',
      display: 'flex',
      flexDirection: 'row',
      padding: '32px',
      [MediaQueries.sm]: {
        flexDirection: 'Column',
      },
      [MediaQueries.md]: {
        flexDirection: 'Column',
      },

      '.expert_call': {
        display: 'flex',
        [MediaQueries.md]: {
          marginBottom: '30px',
        },
        [MediaQueries.sm]: {
          marginBottom: '0px',
          flexDirection: 'Column',
        },
      },
      '.callusnow': {
        marginRight: '50px',
        [MediaQueries.md]: {
          marginRight: '40px',
        },

        '.callustxt': {
          fontSize: '18px',
          lineHeight: '32px',
          letterSpacing: '0px',
          textAlign: 'left',
          fontWeight: 500,
        },
        '.callnowithicon': {
          display: 'flex',
          paddingTop: '5px',
          alignItems: 'center',

          '.phone-number': {
            margin: '0 16px 0 10px',
            fontSize: '22px',
            lineHeight: '32px',
            letterSpacing: '-0.30000001192092896px',
            textAlign: 'left',
            fontWeight: '300',
          },
        },
      },
    },

    '.or_line': {
      borderLeft: '2px solid #393939',
      opacity: '0.5',
      marginRight: '46px',
      [MediaQueries.sm]: {
        marginTop: '15px',
        marginbottom: '15px',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        border: '0',
      },
      span: {
        position: 'relative',
        background: '#fff',
        backdropFilter: 'blur(24px)',
        left: '-12px',
        padding: '3px 0px',
        alignItems: 'center',
        display: 'flex',
        top: '35%',
        bottom: '50%',
      },
    },

    '.talktoexpert': {
      marginRight: '50px',
      marginTop: '5px',
      [MediaQueries.sm]: {
        marginBottom: '15px',
      },
      '.callustxt': {
        fontSize: '18px',
        lineHeight: '32px',
        letterSpacing: '0px',
        textAlign: 'left',
        fontWeight: 500,
        [MediaQueries.sm]: {
          fontSize: '16px',
        },
      },
      '.callnowithicon': {
        display: 'flex',
        paddingTop: '5px',
        alignItems: 'center',

        p: {
          fontSize: '14px',
          lineHeight: '24px',
        },

        '.phone-number': {
          margin: '0 16px 0 10px',
          fontSize: '22px',
          lineHeight: '32px',
          letterSpacing: '-0.30000001192092896px',
          textAlign: 'left',
          fontWeight: '300',
        },
      },
    },

    '.callme': {
      form: {
        display: 'flex',
        alignItems: 'center',

        [MediaQueries.sm]: {
          flexDirection: 'Column',
        },
        '.phonenofield': {
          div: {
            maxWidth: '300px',
            padding: '10px 16px',
          },
        },
      },
      input: {
        width: '100%',
        borderRadius: '4px',
      },

      button: {
        minWidth: '255px',
        background: '#E52500',
        border: '0',
        color: '#fff',
        height: '51px',
        marginLeft: '32px',
        fontSize: '14px',
        borderRadius: '8px',
        lineHeight: '18px',
        letterSpacing: '0.875px',
        textAlign: 'center',

        [MediaQueries.sm]: {
          marginLeft: '0px',
          marginTop: '16px',
          marginBottom: '16px',
          padding: '20px',
        },
      },
    },
  },
};

export const FeatureBulletLink = {};

export const itemsContainerCss = css({
  paddingBottom: '0px',
  paddingTop: '0px',

  '.bulletimg': {
    margin: '160px 0',
  },

  '.imgsec': {
    marginLeft: '8.333333333333332%',
    marginRight: '8.333333333333332%',

    '.img1': {
      width: '100%',
    },
    '.img2': {
      position: 'absolute',
      top: '272px',
      left: '281px',
      width: '100%',
    },
    img: {},
  },
});
